import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DistributionArtFileComponent } from '../distribution-art-file/distribution-art-file.component';
import { MainService } from 'src/app/services/main.service';
import { CampaignsService } from 'src/app/services/campaigns.service';
import Swal from 'sweetalert2';
import { DistributionArtPreviewComponent } from '../distribution-art-preview/distribution-art-preview.component';

@Component({
  selector: 'app-distribution-art',
  templateUrl: './distribution-art.component.html',
  styleUrls: ['./distribution-art.component.scss']
})
export class DistributionArtComponent implements OnInit {

  strategy: any;
  artFiles: any;
  isLoading = true;
  canUploadArt: boolean = false;
  folder_camp: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private campaignService : CampaignsService,
    private main : MainService,
    private matDialog: MatDialog,
    private dialogRef: MatDialogRef<DistributionArtComponent>,
  ) {
    this.strategy = this.data.strategy;
    this.folder_camp = this.data.folder_camp;
    this.loadData();
    this.canUploadArt = !this.data.islocked && this.campaignService.hasPermissions("upl_art",false,true);
   }

  ngOnInit(): void {
    
  }

  loadData(){
    this.campaignService.getStrategyArts(this.strategy.id).subscribe(
      (result:any) => {
        this.isLoading = false;
       this.artFiles = result.data;
      },
      (err:any) => {
        this.isLoading = false;
        if(err.error.message != "No valid art files were found in the request")
        {
          Swal.fire({
            icon: 'error',
            title: 'Error al obtener registros',
            text: 'Ocurrió un error al obtener los registros.'
          });
        }
      }
    );
  }

  openDialogArtUploadFile() {
    this.matDialog.open(DistributionArtFileComponent, {
      panelClass: ['dialogs-main'],
      closeOnNavigation: false,
      data: {
        folder_camp: this.folder_camp,
        strategy : this.data.strategy
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) {
          this.dialogRef.close({ reload: true });
        }
      }
    );
  }
  
  openPreview() {
    const previewUrl = this.artFiles?.[0]?.url_cli;

    if (!this.isPdfUrl(previewUrl)) {
      Swal.fire({
        icon: 'warning',
        title: 'Archivo no compatible',
        text: 'La vista previa sólo está disponible para archivos PDF.'
      });
      return;
    }

    this.matDialog.open(DistributionArtPreviewComponent, {
      panelClass: ['dialogs-xl'],
      data: {
        strategy : this.data.strategy,
        artFiles: this.artFiles,
        tipo: 1
      }
    }).afterClosed().subscribe(
      resp => {
        if(resp?.reload) {
          this.dialogRef.close({ reload: true });
        }
      }
    );
  }

  private isPdfUrl(url?: string): boolean {
    if (!url) {
      return false;
    }

    try {
      const parsedUrl = new URL(url);
      const isHttpUrl = parsedUrl.protocol === 'https:' || parsedUrl.protocol === 'http:';
      return isHttpUrl && parsedUrl.pathname.toLowerCase().endsWith('.pdf');
    } catch {
      return false;
    }
  }

}
